import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, throwError } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { StaticData } from '../models/static-data.model';

export const STATIC_STORAGE_KEY = 'STATIC';
const STATIC_REQUEST_TIMEOUT_MS = 30_000;

function normalizeStaticResponse(resp: unknown): StaticData {
  if (resp == null) return {};
  const obj = resp as Record<string, unknown>;
  const body = obj['body'];
  if (typeof body !== 'undefined' && body !== null) return (body as StaticData) ?? {};
  return (obj as StaticData) ?? {};
}

@Injectable({ providedIn: 'root' })
export class BackendService {
  constructor(private http: HttpClient) {}

  createUrl(path: string): string {
    return `${environment.WG_AGENTS_BASE_URL}${path}`;
  }

  createAgentsUrl(path: string): string {
    return `${environment.WG_AGENTS_BASE_URL}${path}`;
  }

  /** URLs on the dedicated connectors API (wg-agents-connectors-api) — the
   *  per-user OAuth Connections endpoints, cut over from the hub API. */
  createConnectorsUrl(path: string): string {
    return `${environment.WG_CONNECTORS_BASE_URL}${path}`;
  }

  getStatic(): Observable<StaticData> {
    const url = this.createUrl(environment.BASE_API.STATIC);
    return this.http.get<unknown>(url).pipe(
      timeout(STATIC_REQUEST_TIMEOUT_MS),
      tap((raw) => { if (!environment.production) console.debug('[Backend] getStatic raw', raw); }),
      map(normalizeStaticResponse),
      catchError((err) => {
        if (err?.name === 'TimeoutError') {
          return throwError(() => ({ message: 'Server is taking too long. Please try again.', status: 408 }));
        }
        return throwError(() => err);
      })
    );
  }
}
